module.exports = __webpack_public_path__ + "img/dinero.a669de3f.png";